import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@e2n/ui';
import { useTranslation } from 'react-i18next';
import { ApiKeyClipboard, ApiKeyInfo } from './ApiKeyClipboard.tsx';
import { ZugangActions } from './ZugangActions.tsx';
import { ZugangSwitch } from './ZugangSwitch.tsx';
import { ZugangZaehler } from './ZugangZaehler.tsx';
import { PartnerBadge, type PartnerTemplate } from './PartnerBadge.tsx';

export type Zugang = {
  uid: string;
  beschreibung: string;
  apiKey: string;
  aktiv: boolean;
  partnerTemplate?: PartnerTemplate | null;
};

type ZugaengeTableProps = {
  zugaenge: Zugang[];
  zugangLimit: number;
};

export function ZugaengeTable({ zugaenge, zugangLimit }: ZugaengeTableProps) {
  const { t } = useTranslation();

  return (
    <>
      <Table>
        <TableHeader className="text-xs text-neutrals-700">
          <TableRow>
            <TableHead className="px-1">
              {t('domain.e2nApi.zugaenge.tabelle.titel')}
            </TableHead>
            <TableHead className="px-1">
              <span className="flex items-center gap-1">
                {t('domain.e2nApi.zugaenge.tabelle.apiKey')}
                <ApiKeyInfo seite="right" />
              </span>
            </TableHead>
            <TableHead className="px-1">
              {t('domain.e2nApi.zugaenge.tabelle.aktiv')}
            </TableHead>
            <TableHead className="w-10" />
          </TableRow>
        </TableHeader>
        <TableBody>
          {zugaenge.map((zugang) => (
            <TableRow key={zugang.uid} className="h-14 last:border-b-0">
              <TableCell className="px-1 text-sm text-neutrals-900">
                <span className="flex items-center gap-2">
                  {zugang.beschreibung}
                  {zugang.partnerTemplate && (
                    <PartnerBadge
                      partnerTemplate={zugang.partnerTemplate}
                      infoSeite="right"
                    />
                  )}
                </span>
              </TableCell>
              <TableCell className="px-1 text-sm">
                <ApiKeyClipboard apiKey={zugang.apiKey} />
              </TableCell>
              <TableCell className="px-1">
                <ZugangSwitch uidZugang={zugang.uid} aktiv={zugang.aktiv} />
              </TableCell>
              <TableCell className="px-1">
                <ZugangActions
                  uidZugang={zugang.uid}
                  editierbar={zugang.partnerTemplate == null}
                  darstellung="menue"
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <ZugangZaehler
        anzahl={zugaenge.length}
        max={zugangLimit}
        className="pt-6"
      />
    </>
  );
}
